import { getAccessToken } from '@/lib/auth';
import { getPlatformApiUrl } from '@/lib/platform-api-url';

export interface AttachedFile {
  file: File;
  url?: string;
  uploading: boolean;
  error?: string;
}

export async function uploadScreenshot(file: File): Promise<string> {
  const accessToken = await getAccessToken();
  const formData = new FormData();
  formData.append('file', file);

  const headers: HeadersInit = {
    'X-Request-ID': crypto.randomUUID(),
    'Idempotency-Key': crypto.randomUUID(),
  };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const response = await fetch(`${getPlatformApiUrl()}/platform/v1/support/attachments`, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: { message: 'Upload failed' } }));
    const message =
      (err as { error?: { message?: string }; detail?: string }).error?.message ??
      (err as { detail?: string }).detail ??
      `Upload failed: ${response.status}`;
    throw new Error(message);
  }

  const data = (await response.json()) as { url: string; filename: string };
  return data.url;
}
